jQuery.extend(jQuery.validator.messages, {
      required: "Dit is een verplicht veld.",
      remote: "Dit e-mailadres is al bekend bij ons.",
      email: "Vul hier een geldig email adres in.",
      url: "Vul hier een geldige URL in.",
      date: "Vul hier een geldige datum in.",
      dateISO: "Vul hier een geldige datum in (ISO).",
      number: "Vul hier een geldig nummer in.",
      digits: "Vul hier alleen nummers in.",
      creditcard: "Vul hier een geldig credit card nummer in.",
      equalTo: "Vul hier dezelfde waarde in.",
      accept: "Vul hier een waarde in met een geldige extensie.",
      maxlength: jQuery.format("Vul hier maximaal {0} tekens in."),
      minlength: jQuery.format("Vul hier minimaal {0} tekens in."),
      rangelength: jQuery.format("Vul hier een waarde in van minimaal {0} en maximaal {1} tekens."),
      range: jQuery.format("Vul hier een waarde in van minimaal {0} en maximaal {1}."),
      max: jQuery.format("Vul hier een waarde in kleiner dan of gelijk aan {0}."),
      min: jQuery.format("Vul hier een waarde in groter dan of gelijk aan {0}.")
});


var myInterval = null;
function initPhotoSlide() {
	if (jQuery('div#board img').size() > 1) {
		myInterval = setInterval(function() {
			// photo slider
			var active = jQuery("div#board img.current");
			if(active.length == 0)
				active = jQuery("div#board img:first");
			var next = active.next().length ? active.next() : jQuery("div#board img:first");
			jQuery(active).removeClass("current").fadeOut('slow');
			next.addClass("current").fadeIn('slow');
		}, 6000); 
	}
};

(function($){
    $.fn.setEqualHeights = function(){
        var config = jQuery.extend({
            }, arguments[0] || {}),
            counter = 0,
            perRow = 0,
            $elems = $(this);
        $elems.height('auto');
        while(counter < $elems.length) {
            perRow = 0;
            $elems.slice(counter).each(function (ind) {
                if (ind != 0 && $(this).offset().top != $elems.eq(ind + counter - 1).offset().top)
                    return false;
                perRow++;
            });
            if(perRow > 1) {
                $elems.slice(counter, counter + perRow).height(Math.max.apply(Math, $elems.slice(counter, counter + perRow).map(function () {
                    if($(this).css('box-sizing') == 'border-box'){
                        return $(this).outerHeight(false);
                    }
                    return $(this).height();
                }).get()));
            }
            counter += perRow;
        }
    };
})(jQuery);

jQuery(document).ready(function() {
  	jQuery("a[href^='http://'],a[href^='www.'],a[href^='https://'],a[rel='external']").not("a[href^='http://www.mkbaccountants.nl']").attr('target','_blank');
  	jQuery(".fancybox").fancybox();
	
	jQuery(document).ready(function(){
		jQuery('ul.sf-menu').superfish({ 
          delay:       500,                            // one second delay on mouseout 
          animation:   {opacity:'show',height:'show'},  // fade-in and slide-down animation 
          speed:       'fast',                          // faster animation speed 
          autoArrows:  false,                           // disable generation of arrow mark-up 
          dropShadows: false                            // disable drop shadows 
      }); 
	});
	jQuery('div#contentwrap_lft ul li').hover(function() {
		jQuery(this).addClass('hover');
	}, function() {
	    jQuery(this).removeClass('hover');
	});	
	initPhotoSlide();

	function PhotoSlideFix() {
		var w = jQuery('.restyling div#board').width();
		jQuery('.restyling div#board').find('img').css({'width':'100%','maxWidth':w});
	}
	var im = null;
	$(window).resize(function() {
		im = setInterval(function() {
			PhotoSlideFix();
		},300);
	});
	PhotoSlideFix();
	
	jQuery('#blog_form input[name=name]').click(function() {
		if (this.value.toLowerCase() == 'je naam...') {
			this.value = '';
		} else if (this.value == '') {
			this.value = this.defaultValue;
		}
		return false;
	});
	jQuery('#blog_form input[name=email]').click(function() {
		if (this.value.toLowerCase() == 'je e-mail...') {
			this.value = '';
		}
		return false;
	});
	jQuery('#blog_form textarea[name=comment]').click(function() {
		if (this.value.toLowerCase() == 'bericht') {
			this.value = '';
		}
		return false;
	});

	function validateEmail(email) {
	    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(email);
	}

  jQuery('.mobile-clicker').click(function() {
  	var b = jQuery('#footer').offset().top;
  	jQuery('#mobilemenu').toggleClass('on').height(b-125);
  	$(this).find('i.fa').toggleClass('fa-bars fa-close');
  });
  jQuery('#mobilemenu').click(function(event) {
  	if (event.target === this) {
  		jQuery('.mobile-clicker').trigger('click');
  	}
  	return;
  });

  	function he() {
		jQuery('.block_rgt > .block').setEqualHeights();
		jQuery('#sidebar > .block').setEqualHeights();
		jQuery('#two_column > .block').setEqualHeights();
		console.log('173');
 	}
  	var im2;
  	if (jQuery('.block_rgt, #sidebar, #two_column').find('> .block').length) {
	  	window.onresize = function(){
	  		clearTimeout(im2);
	  		im2 = setTimeout(he,300);
	  	};
	  	he();
	}
});

function fixHeights() {
	if (jQuery('div#two_column').length > 0) {
		var maxHeight = jQuery('div#contentwrap').height();
		if (jQuery('div#sidebar').height() > maxHeight) {
			maxHeight = jQuery('div#sidebar').height();
		}
		jQuery('div#two_column').css({bottom: '0px', 'position' : 'absolute'});
		jQuery('div#contentwrap, div#sidebar').height(maxHeight);
		console.log(maxHeight);
	}
}
jQuery(window).load(function() {
	/*var is = null;
	$(window).resize(function() {
		is = setInterval(function() {
			fixHeights();
		},300);
	});*/
	fixHeights();
});